import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { authLink } from './authLink';
import { errorCatchLink } from './errorCatchLink';
import { uriLink } from './uriLink';

export const apolloClient = new ApolloClient({
  link: from([authLink, errorCatchLink, uriLink]),
  cache: new InMemoryCache(),
});
